import { ChangeDetectionStrategy, Component, HostListener, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UIService } from '@services';
import {
  AdditionalServiceConfig,
  RemoteDescription,
  VorOrtDescription,
} from '@vi-iot/client/index';
import { ViessmannUIModule } from '@vi-iot/ui/viessmann-ui.module';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { ViguideBreakpoints } from 'src/app/shared/common/ui-constants';
import { AdditionalServiceExpandableComponent } from './additional-service-expandable/additional-service-expandable.component';
import { BookingStore } from '@store';

@Component({
  selector: 'app-additional-services',
  standalone: true,
  imports: [CommonStandaloneModule, ViessmannUIModule, AdditionalServiceExpandableComponent],
  templateUrl: './additional-services.component.html',
  styleUrl: './additional-services.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalServicesComponent {
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.isAboveMedium = this.uiService.isAboveMediumWidth();
  }
  isAboveMedium = window.innerWidth >= ViguideBreakpoints.md;

  expanded: boolean[] = [];

  remoteDescription: string[] = RemoteDescription;

  vorOrtDescription: string[] = VorOrtDescription;

  configForMobile = AdditionalServiceConfig;

  popupTitle: string;
  constructor(
    public uiService: UIService,
    public bookingStore: BookingStore,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { popupTitle: string }
  ) {
    this.popupTitle = this.data?.popupTitle;
  }
}
